import { ImageModule } from 'primeng/image';
import { CommonModule } from '@angular/common';
import { NgImageSliderModule } from 'ng-image-slider';
import { TranslateModule } from '@ngx-translate/core';
import { MatTabsModule } from '@angular/material/tabs';
import {
    Component,
    Input,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'app-lndp-gallery-desktop',
    templateUrl: './lndp-gallery-desktop.component.html',
    styleUrls: ['./lndp-gallery-desktop.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        ImageModule,
        MatTabsModule,
        TranslateModule,
        NgImageSliderModule,
    ],
})
export class LndpGalleryDesktopComponent {
    minLength = 3;
    imageObjectAW: Array<any> = [];
    imageObjectANM: Array<any> = [];
    imageObjectNS: Array<any> = [];
    imageObjectFA: Array<any> = [];

    @Input() imagesAW: any;
    @Input() imagesANM: any;
    @Input() imagesNS: any;
    @Input() imagesFA: any;

    ngOnChanges(changes: SimpleChanges) {
        if (changes) {
            this.imageObjectFA = changes?.imagesFA?.currentValue
                ? changes?.imagesFA?.currentValue
                : [];
            this.imageObjectAW = changes?.imagesAW?.currentValue
                ? changes?.imagesAW?.currentValue
                : [];
            this.imageObjectANM = changes?.imagesANM?.currentValue
                ? changes?.imagesANM?.currentValue
                : [];
            this.imageObjectNS = changes?.imagesNS?.currentValue
                ? changes?.imagesNS?.currentValue
                : [];
        }
    }
}
